import { Box, HStack, VStack, Text, Badge, Menu, IconButton, Portal } from '@chakra-ui/react';
import { FiMoreVertical, FiTrash2, FiMove } from 'react-icons/fi'
import type { ItineraryAssignmentDto, AssignmentStatus } from '../../../types/campaign'
import { getTurfColor } from '../../../lib/mapConfig'
import { doorsAndPeople } from '../../../lib/turfCounts'
import { turfContactRate } from './assignmentProgress'
import { FollowUpKindBadge } from '../followUp/FollowUpKindBadge'

const STATUS_COLORS: Record<AssignmentStatus, string> = { Scheduled: 'gray', InProgress: 'blue', Complete: 'green' }

interface DayAgendaAssignmentCardProps {
  assignment: ItineraryAssignmentDto
  onUnassign: (id: string) => void
  onMove: (assignment: ItineraryAssignmentDto) => void
}

export function DayAgendaAssignmentCard({ assignment, onUnassign, onMove }: DayAgendaAssignmentCardProps) {
  const contactRate = turfContactRate(assignment)
  return (
    <Box borderWidth="1px" borderColor="gray.200" borderLeftWidth="4px" borderLeftColor={getTurfColor(assignment.turfIndex)} borderRadius="md" p={2}>
      <HStack justify="space-between" align="start">
        <VStack align="start" gap={0} flex={1} minW={0}>
          <Text fontWeight="semibold" fontSize="sm" lineClamp={1}>{assignment.turfLabel}</Text>
          <Text color="gray.500" fontSize="xs" lineClamp={1}>{assignment.turfMapLabel}</Text>
          <HStack gap={1} mt={1} flexWrap="wrap">
            <Badge colorPalette={STATUS_COLORS[assignment.status]} fontSize="2xs">{assignment.status}</Badge>
            {assignment.purpose === 'FollowUp' && assignment.followUpKind && (
              <FollowUpKindBadge kind={assignment.followUpKind} customName={assignment.followUpCustomKindName} />
            )}
            <Text fontSize="2xs" color="gray.500">{doorsAndPeople(assignment.turfDoorCount, assignment.turfMemberCount)} · {contactRate}%</Text>
          </HStack>
        </VStack>
        <Menu.Root>
          <Menu.Trigger asChild><IconButton
              aria-label="Assignment actions"
              size="sm"
              variant="ghost"
              minW="44px"
              h="44px"><FiMoreVertical /></IconButton></Menu.Trigger>
          <Portal><Menu.Positioner><Menu.Content>
                <Menu.Item onSelect={() => onMove(assignment)} value='item-0'><FiMove />Move to…</Menu.Item>
                <Menu.Item
                  color="red.500"
                  onSelect={() => onUnassign(assignment.id)}
                  value='item-1'><FiTrash2 />Unassign</Menu.Item>
              </Menu.Content></Menu.Positioner></Portal>
        </Menu.Root>
      </HStack>
    </Box>
  );
}
